// extracted by mini-css-extract-plugin
module.exports = {"class":"ClassPage_class__3QktT","header":"ClassPage_header__2hPm6","className":"ClassPage_className__2uScq"};